<template>
  <div>
    <!-- this is the popup for testnet -->
    <transition enter-active-class="transition ease-out duration-100" enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
      <div class="fixed inset-0 bg-black-primary bg-opacity-50 transition-opacity" v-if="isQRModalShow"></div>
    </transition>
    <transition enter-active-class="transition ease-out duration-100" enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
      <div class="fixed z-50 inset-0 overflow-y-auto" v-if="isQRModalShow">
        <div class="flex items-center justify-center min-h-full text-center sm:p-0">
          <div class="relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-2 sm:max-w-4xl 3xl:max-w-3xl w-full m-2" id="popupQR">
            <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content bg-black-body text-white">
                <div class="modal-body text-justify z-50 relative">
                  <button type="button" class="absolute right-2 top-2 hover:bg-gray-700 w-8 h-8 items-center rounded-md text-sm" @click="closeModel">
                    <font-awesome-icon icon="fa-solid fa-close" class="text-gray-text p-0 text-end inline-block text-sm" />
                  </button>
                  <div class="border-0 text-center">
                    <div class="p-3 md:p-10">
                      <div class="text-center inline-block w-96 h-96 my-2" v-html="qr"></div>
                      <p class="text-center my-2 text-md">To create the namespace, scan this QR code and sign off the transaction using your Sirius {{ network=='testnet'?testnetLabel:mainnetLabel }} mobile wallet. Once complete, you can select "Done" to close this panel.</p>
                      <div class="flex flex-col text-left space-y-2 p-4 mt-4 mb-2 w-full bg-black-card mx-auto text-gray-text text-xs">
                        <ul class="list-outside list-disc space-y-2 px-2">
                        <li>Please move the QR Scanner closer to the QR Code</li>
                        <li>
                          If QR code is unreadable, <a href="#" @click="isFullQRModalShow = true" class="text-blue-400 hover:underline">view full screen</a> at full brightness
                        </li>
                        <li>
                          Please make sure {{ network=='Testnet'?testnetLabel + " 2":mainnetLabel }} node ({{ network=='Testnet'?testneturl:mainneturl }}) is selected on Sirius wallet. <a href="https://developers.xarcade.io/docs/Onboarding/create_token" target="_new" class="hover:underline text-blue-400">Find out More</a>
                        </li>
                      </ul>
                    </div>
                        <div class="p-2 text-center border-0">
                          <button type="button" class="text-white text-center rounded-md duration-150 transition-all disabled:opacity-60 disabled:bg-gray-600 bg-blue-primary px-10 py-2 text-sm" data-bs-dismiss="modal" @click="confirmedButtonPressed" :disabled="isDisabledModalConfirmSubmitButton">Done</button>
                          <div class="text-center w-full" v-if="showUploadingLoader">
                            <div class="inline-block">
                              <div class="items-center mt-4 flex">
                                <svg class="animate-spin h-3 w-3 mr-3 bg-yellow-500 inline-block" viewBox="0 0 24 24"></svg><span class="text-gray-500 text-sm">Creating namespace. Please wait..</span>
                              </div>
                            </div>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <tokensCreateTokenFullSizeModal :isFullQRModalShow="isFullQRModalShow" @closeModel="isFullQRModalShow = false" :qr="qr" />
  </div>
</template>

<script>
import { ref } from "vue";
import { useStore } from "vuex";
import tokensCreateTokenFullSizeModal from "@/modules/tokens/components/modals/tokensCreateTokenFullSizeModal.vue";
export default{
name: 'gamesConfirmCreateNamespaceModal',
  props: {
    isQRModalShow: Boolean,
    qr: String,
    showUploadingLoader: Boolean,
    isDisabledModalConfirmSubmitButton: Boolean,
    network: String,
  },

  components: {
    tokensCreateTokenFullSizeModal,
  },

  emits:[
    'closeModel', //isQRModalShow = false
    'confirmedButtonPressed'
  ],

  setup(props, { emit }){
    const store = useStore();
    const testnetLabel = ref(store.getters['config/configTestnetLabel']);
    const mainnetLabel = ref(store.getters['config/configMainnetLabel']);
    const testneturl = ref(store.getters['config/getTestnetApi']);
    const mainneturl = ref(store.getters['config/getMainnetApi']);
    const closeModel = () => {
      let isConfirmedClose = confirm('Are you sure you want to close? Because this step will not continue if you click OK');
      if(isConfirmedClose){
        emit('closeModel');
      }
    }

    const confirmedButtonPressed = () => {
      emit('confirmedButtonPressed');
    }

    const isFullQRModalShow = ref(false);

    return {
      testnetLabel,
      mainnetLabel,
      testneturl,
      mainneturl,
      closeModel,
      confirmedButtonPressed,
      isFullQRModalShow,
    }
  }
}
</script>
<style lang="scss" scoped>

</style>